/**
 * Downloads Module
 * Download links handler for cross-origin downloads
 */

export function initDownloadLinks() {
  try {
    const downloadLinks = document.querySelectorAll("a[download]");

    downloadLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        const url = link.getAttribute("href");
        const filename = link.getAttribute("download");

        // Check if it's cross-origin
        if (!url.startsWith(window.location.origin)) {
          e.preventDefault();
          handleCrossOriginDownload(url, filename);
        }
      });
    });

    console.log(`✅ Download links initialized: ${downloadLinks.length}`);
  } catch (error) {
    console.error("❌ Error initializing download links:", error);
  }
}

function handleCrossOriginDownload(url, filename) {
  // Try different methods
  Promise.resolve()
    .then(() => {
      // Method 1: Try fetch
      return fetch(url).then((response) => {
        if (!response.ok) throw new Error("Fetch failed");
        return response.blob();
      });
    })
    .then((blob) => {
      // Success: Create download
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
    })
    .catch((error) => {
      console.warn("Direct download failed, opening in new tab:", error);
      // Fallback: Open in new tab
      window.open(url, "_blank");
    });
}
